import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {DocumentiDaConservareComponent} from './documenti-da-conservare';


let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.documenti-da-conservare', {
      url: '/documenti-da-conservare',
      ncyBreadcrumb: {
        label: 'Documenti da conservare',
        parent: 'home.admin'
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'Documenti da conservare',
      },
      'views': {
        'homeContent': {
          template: '<documenti-da-conservare flex="100"></documenti-da-conservare>'
        }
      }
    });

};
stateConfig.$inject = ['$stateProvider'];

export const DocumentiDaConservareModule: string = ng
  .module('documenti-da-conservare', ['ui.bootstrap', uiRouter])
  .component('documentiDaConservare', DocumentiDaConservareComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/documenti-da-conservare/documenti-da-conservare.module.ts